(function () {
  const loadMoreBtns = document.querySelectorAll('.load-more-toplist');

  if (loadMoreBtns.length === 0) {
    return;
  }
  loadMoreBtns.forEach(btn => {
    let page = 1;
    const source = btn.getAttribute('data-source');
    const perPage = btn.getAttribute('data-per-page');
    const total = btn.getAttribute('data-total');
    const toplistId = btn.getAttribute('data-toplist-id');
    const dbBrands = btn.getAttribute('data-db-brands');
    const params = JSON.parse(btn.getAttribute('data-params') ?? '{}');

    btn.addEventListener('click', function (event) {
      event.preventDefault();

      fetch(load_more_data.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          nonce: load_more_data.nonce,
          locale: load_more_data.locale,
          page: page,
          source: source,
          perPage: perPage,
          total: total,
          toplistId: toplistId,
          dbBrands: dbBrands,
          params: JSON.stringify(params),
          action: 'more_brands'
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          return response.text();
        })
        .then(response => {
          page++;
          btn.previousElementSibling.insertAdjacentHTML('beforeend', response);

          if (page == total) {
            btn.remove();
          } else {
            btn.disabled = false;
          }

          const loadMoreEvent = new CustomEvent('loadMoreTriggered', {
            detail: {
              type: 'toplist',
            }
          });
    
          document.dispatchEvent(loadMoreEvent);
        })
        .catch(error => {
          console.error('Error:', error);
          btn.disabled = false;
        });

      btn.disabled = true;
    });
  });
})();